import React, { createContext, useContext, useState, ReactNode } from 'react';

export function resolveInitialCourseTab({
  searchParams,
  hasOverviewContent,
}: {
  searchParams: URLSearchParams;
  hasOverviewContent: boolean;
}) {
  if (searchParams.get('tab') === 'Websites') return 'Websites';
  if (searchParams.get('assessmentResult') || searchParams.get('tab') === 'Assessments') {
    return 'Assessments';
  }
  if (searchParams.get('step')) return 'Modules';
  return hasOverviewContent ? 'Overview' : 'Modules';
}

interface CourseNavigationContextType {
  activeCourseTab: string;
  setActiveCourseTab: (tab: string) => void;
}

const CourseNavigationContext = createContext<CourseNavigationContextType | undefined>(undefined);

export const useCourseNavigation = (): CourseNavigationContextType => {
  const context = useContext(CourseNavigationContext);
  if (!context) {
    throw new Error('useCourseNavigation must be used within a CourseNavigationProvider');
  }
  return context;
};

interface CourseNavigationProviderProps {
  children: ReactNode;
}

export const CourseNavigationProvider: React.FC<CourseNavigationProviderProps> = ({ children }) => {
  const [activeCourseTab, setActiveCourseTab] = useState('Overview');

  return (
    <CourseNavigationContext.Provider value={{ activeCourseTab, setActiveCourseTab }}>
      {children}
    </CourseNavigationContext.Provider>
  );
};

export default CourseNavigationContext;
